export default {
  zh: {
    backToWorkFlowList: '返回工作流列表',
    addWorkFlow: '新增工作流',
    editWorkFlow: '编辑工作流',
    ruleSetup: '规则设置',
    criteria: '条件',
    triggerActions: '触发行为',
    workFlowName: '工作流名称',
    description: '描述',
    when: '触发时机',
    addTrigger: '添加触发器',
    trigger: '触发',
    object: '类型',
    actions: '行为',
    addAction: '新增行为',
    field: '字段',
    action: '行为',
    value: '值',
    tips: {
      triggerSelectField: '请选择字段',
    },
    distribution: '分配',
    equallyDistributed: '平均分配',
    modalTableHeader: {
      item: '项目',
      weight: '权重',
      percentage: '百分比',
    },
    errors: {
      triggerNeeded: '触发器不能为空',
    }
  },
  en: {
    backToWorkFlowList: 'Back to Workflow List',
    addWorkFlow: 'Add New Workflow',
    editWorkFlow: 'Edit Workflow',
    ruleSetup: 'Rule Setup',
    criteria: 'Criteria',
    triggerActions: 'Trigger Actions',
    workFlowName: 'Workflow Name',
    description: 'Description',
    when: 'When',
    addTrigger: 'Add Trigger',
    trigger: 'Trigger',
    object: 'Object',
    actions: 'Actions',
    addAction: 'Add Action',
    field: 'Field',
    action: 'Action',
    value: 'Value',
    tips: {
      triggerSelectField: 'Please select field',
    },
    distribution: 'Distribution',
    equallyDistributed: 'Equally Distributed',
    modalTableHeader: {
      item: 'Item',
      weight: 'Weight',
      percentage: 'Percentage',
    },
    errors: {
      triggerNeeded: 'Trigger cannot be empty',
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/i18n.js